import { ReactComponent as Svg2 } from "../../assets/weAreSpeakingLouderSection/2.svg";
import {ReactComponent as Svg1500} from "../../assets/weAreSpeakingLouderSection/1500+.svg"
import {ReactComponent as Svg25} from "../../assets/weAreSpeakingLouderSection/25.svg"
import { ReactComponent as Svg15 } from "../../assets/weAreSpeakingLouderSection/15.svg";

const weAreSpeakingLouderData = [
  {
    id: 1,
    svg: <Svg2/>,
    text: "Days",
  },
  {
    id: 2,
    svg: <Svg1500/>,
    text: "Est. Attendees",
  },
  {
    id: 3,
    svg: <Svg25/>,
    text: "Speakers",
  },
  {
    id: 4,
    svg: <Svg15/>,
    text: "Sessions",
  },
];

export default weAreSpeakingLouderData 
